import {Injectable} from '@angular/core';

import {HTTPHelperService} from './http-helper.services';

@Injectable()
export class StaffService {

  constructor(private httpHelper: HTTPHelperService) {
  }

  public getProfile({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadDashboard({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStaffSubject({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadChapter({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public editChapter({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteChapter({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public addChapters({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public loadObjectiveQuestions({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public addObjectiveQuestions({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public editObjectiveQuestions({url, params}) {
    return this.httpHelper.putFunction({url: url, params: params});
  }

  public deleteObjectiveQuestions({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }

  public loadClass({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStudentAttendance({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public loadStudentPerformance({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadOverAllStudentAttendanceCountByStaffId({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public updateAttendance({ url, params }) {
    return this.httpHelper.putFunction({ url: url, params: params });
  }

  public saveAttendance({ url, params }) {
    return this.httpHelper.postFunction({ url: url, params: params });
  }

  public getImage({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public loadStudentList({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public loadStudent({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public getStudentById({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public deleteStudent({ url, params }) {
    return this.httpHelper.deleteFunction({ url: url, params: params });
  }

  public loadStudentLeave({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public loadStudentPermission({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public loadStaffLeave({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public addStaffLeave({ url, params }) {
    return this.httpHelper.postFunction({ url: url, params: params });
  }

  public editStaffLeave({ url, params }) {
    return this.httpHelper.putFunction({ url: url, params: params });
  }

  public loadStaffPermission({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public addStaffPermission({ url, params }) {
    return this.httpHelper.postFunction({ url: url, params: params });
  }

  public editStaffPermission({ url, params }) {
    return this.httpHelper.putFunction({ url: url, params: params });
  }

  public loadStaffTimetable({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public uploadImage(url, formData) {
    return this.httpHelper.postImageUpload(url, formData);
  }

  public loadStaffNotification({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public postStaffNotification({ url, params }) {
    return this.httpHelper.postFunction({ url: url, params: params });
  }

  public postStaffNotificationToGroup({ url, params }) {
    return this.httpHelper.postFunction({ url: url, params: params });
  }

  public postStaffNotificationToMember({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postStaffNotificationToStudent({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public postStaffNotificationToClass({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }

  public deleteNotification({url, params}) {
    return this.httpHelper.deleteFunction({url: url, params: params});
  }
  
  public loadStaffActivity({ url, params }) {
    return this.httpHelper.getFunction({ url: url, params: params });
  }

  public loadStaffExam({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public loadStaffExamResult({url, params}) {
    return this.httpHelper.getFunction({url: url, params: params});
  }

  public setStaffExamResult({url, params}) {
    return this.httpHelper.postFunction({url: url, params: params});
  }
}
